import type { Advantage } from '@application/components';

export interface MtAdvantagesPageData {
  items: Advantage[];
}

export interface MtAdvantagesPageProps extends MtAdvantagesPageData {}
